import * as React from "react";
import { AnimatePresence, motion } from "motion/react";

function Table<T>({
  data,
  config,
  expandedIds = [],
}: {
  data: T[];
  config: {
    id: (value: T) => string;
    cols: {
      key: string;
      label: string;
      render: (value: T) => React.ReactNode;
      width?: string;
      align?: "left" | "right" | "center";
    }[];
    renderExpanded?: (value: T) => React.ReactNode;
  };
  expandedIds?: string[];
}) {
  return (
    <table className="nice-table">
      <thead>
        <tr>
          {config.cols.map((col) => (
            <th
              key={col.key.toString()}
              style={col.width ? { width: col.width } : {}}
              className={col.align ? `align-${col.align}` : ""}
            >
              {col.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((item) => (
          <React.Fragment key={config.id(item)}>
            <tr
              className={classes({
                expanded: expandedIds.includes(config.id(item)),
              })}
            >
              {config.cols.map((col) => (
                <td
                  key={col.key.toString()}
                  className={classes({
                    [`align-${col.align}`]: !!col.align,
                  })}
                >
                  {col.render(item)}
                </td>
              ))}
            </tr>
            <AnimatePresence>
              {expandedIds.includes(config.id(item)) &&
                config.renderExpanded && (
                  <motion.tr
                    className="expanded-view"
                    key={`${config.id(item)}-expanded`}
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                  >
                    <td colSpan={config.cols.length}>
                      {config.renderExpanded(item)}
                    </td>
                  </motion.tr>
                )}
            </AnimatePresence>
          </React.Fragment>
        ))}
      </tbody>
    </table>
  );
}

function classes(conditions: Record<string, boolean>) {
  return Object.entries(conditions)
    .filter(([, v]) => v)
    .map(([k]) => k)
    .join(" ");
}

export default Table;
